import { ISubscriptionItem } from '~/src/api/common-types/sale-package';
import { ActiveCardWrapper, ArrowPointer, TariffCardMinimal } from '~/src/components/TariffCardMinimal';
import { IFullBuyTariff } from '~/src/features/full-buy/store/tariffTransformer';

import { ISubscription } from '../store/helpers/tariffTransformerHelpers';

interface IProps {
    tariffPackages: IFullBuyTariff[],
    selectedPackageId?: number,
    withArrowPointer?: boolean,
    onSelectTariff: (tariff: IFullBuyTariff) => void,
    sendAnalytics?: (tariffName: string) => void,
}

export const renderTariffList = ({ tariffPackages, selectedPackageId, withArrowPointer, onSelectTariff, sendAnalytics }: IProps) => {
    const selectTariffHandler = (_tariff: IFullBuyTariff) => {
        onSelectTariff(_tariff);
        typeof sendAnalytics === 'function' && sendAnalytics(_tariff.tariff_name);
    };

    return (
        tariffPackages.map(tariff => {
            const isActive = tariff.sale_package_id === selectedPackageId;
            const imageBackground = tariff.image_background_webp ? tariff.image_background_webp : tariff.image_background;
            const sourceData: (ISubscriptionItem | ISubscription)[] = tariff?.salePackageLinks?.length > 0
            ? tariff.salePackageLinks.flatMap((packageLink) => packageLink.subscriptions || [])
            : tariff.subscriptions;

            const uniqueSourceData = sourceData.reduce<(ISubscriptionItem | ISubscription)[]>((acc, item) => {
                if (!acc.some((accItem) => accItem.id === item.id)) {
                    acc.push(item);
                }
                return acc;
            }, []);

            const subscriptions = uniqueSourceData.map((item) => ({
                id: item.id,
                title: item.title,
                image: item.image,
                image_webp: item.image_webp || '',
                sort: item.sort,
            }));

            return (
                <ActiveCardWrapper
                    key={tariff.sale_package_id}
                    isActive={isActive}
                    onClick={isActive ? () => null : () => selectTariffHandler(tariff)}
                >
                    <TariffCardMinimal
                        title={tariff.title}
                        price={tariff.price}
                        priceAction={tariff.promoPrice}
                        speed={`${tariff.speed}`}
                        channelCount={Number(tariff.sdCount) + Number(tariff.hdCount)}
                        subscriptions={subscriptions}
                        imageBackground={imageBackground}
                        colorText={tariff.colorText}
                        bgColor={tariff.bgColor}
                        isLightCard={true}
                    />
                    {withArrowPointer &&
                        <ArrowPointer isActive={isActive}/>
                    }
                </ActiveCardWrapper>
            );
        })
    );
};
